import React from 'react';

import _ from 'lodash';
import { UsergroupAddOutlined, ApartmentOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import styles from './style.less';

export default ({ onClick, title, enviroment }) => {
  return (
    <Tooltip placement="bottom" title={title} overlayClassName={styles.tooltip}>
      {enviroment ? (
        <ApartmentOutlined key={_.uniqueId()} onClick={onClick} />
      ) : (
        <UsergroupAddOutlined key={_.uniqueId()} onClick={onClick} />
      )}
    </Tooltip>
  );
};
